import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import Meeting from '@/components/Meeting/Meeting';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import { useCreateAirwallexPaymentCheckoutMutation } from '@/store/apis/paymentApi';
import { Button, Card, Col, message, Row, Typography } from 'antd';
import { conveyancingInfo } from '../../constant/conveyancingInfo';
import Feedback from '@/components/Layout/Header/Feedback';
import { ConveyancingInquiry } from '../../components/InquiryForm';
import { ICON_MAPPER } from '@/constant/icons';
// ... existing imports ...

const GetQuotePage = () => {
  const [
    createAirwallexPaymentCheckout,
    { isLoading: createAirwallexPaymentCheckoutLoading },
  ] = useCreateAirwallexPaymentCheckoutMutation();

  const generateCheckoutSession = async () => {
    try {
      const response = await createAirwallexPaymentCheckout({}).unwrap();
      message.success('Payment Link successfully generated');
      window.open(response.data.redirect, '_blank');
    } catch (error) {
      message.error('Something went wrong');
    }
  };
  return (
    <>
      <div style={{ marginTop: '20px' }}>
        <Row gutter={[30, 30]}>
          <Col xs={24} lg={12}>
            <Card style={{ height: '100%' }} title="Why Use Odin Conveyancing?">
              <div>
                {conveyancingInfo.map((item, index) => (
                  <div key={index} style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '8px',
                      }}
                    >
                      <span
                        style={{
                          marginRight: '12px',
                          fontSize: '20px',
                          color: '#1890ff',
                        }}
                      >
                        {ICON_MAPPER[item.icon] || ICON_MAPPER['document']}
                      </span>
                      <Typography.Title
                        level={5}
                        style={{
                          margin: '0px',
                          fontStyle: 'italic',
                          fontWeight: 'bold',
                        }}
                      >
                        {item?.title}
                      </Typography.Title>
                    </div>
                    <Typography.Text>{item?.description}</Typography.Text>
                  </div>
                ))}
              </div>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card title="Get a quote for your transaction">
              <ConveyancingInquiry />
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Meeting
              title="Book a Free Consultation Call"
              meetingUrl="https://meetings.hubspot.com/kaustuv-karki?embed=true"
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default GetQuotePage;
